import { useSnackbar } from 'notistack'

import { useAuthentication } from '../../providers/auth-provider'
import Api from '../api'

const useBookmarks = () => {
  const { enqueueSnackbar } = useSnackbar()
  const { ownUser, setOwnUser } = useAuthentication()
  const bookmarks = ownUser?.metadata?.centralBookmarks ?? []

  const isBookmarked = (type: 'account', id: string | number) => !!bookmarks.find((b) => b.type === type && b.id === Number(id))

  const saveToBookmarks = async (type: 'account', id: string | number, bookmarkMetadata: Record<string, string>) => {
    if (ownUser && id) {
      const path = window.location.pathname
      const newBookmarks = [...bookmarks, { type, id: Number(id), path, metadata: bookmarkMetadata }]
      const payload = {
        ...ownUser,
        metadata: {
          ...ownUser.metadata,
          centralBookmarks: newBookmarks,
        },
      }

      const res = await Api.put(`/api/users/${ownUser.id}`, payload)
      if (res.ok) {
        setOwnUser(res.body)
        enqueueSnackbar('Saved to bookmarks')
      } else {
        enqueueSnackbar('Could not save to bookmarks', { variant: 'error' })
      }
    }
  }

  const removeFromBookmarks = async (type: 'account', id: string | number) => {
    if (ownUser && id) {
      const newBookmarks = bookmarks.filter((b) => !(b.type === type && b.id === Number(id)))
      const payload = {
        ...ownUser,
        metadata: {
          ...ownUser.metadata,
          centralBookmarks: newBookmarks,
        },
      }

      const res = await Api.put(`/api/users/${ownUser.id}`, payload)
      if (res.ok) {
        setOwnUser(res.body)
        enqueueSnackbar('Removed from bookmarks')
      } else {
        enqueueSnackbar('Could not remove from bookmarks', { variant: 'error' })
      }
    }
  }

  return { bookmarks, isBookmarked, saveToBookmarks, removeFromBookmarks }
}

export default useBookmarks
